import { CmsObjectWithDefault } from '@components/Cms/types';

export type ChangePasswordContainerCmsKey =
    | 'passwordValidationEmpty'
    | 'confirmPasswordValidationMatch'
    | 'confirmPasswordValidationLength'
    | 'pleaseTryAgain'
    | 'technicalDifficulty'
    | 'serverError'
    | 'passwordIsChangedSuccessfully'
    | 'youAreNotAllowedToLogIn'
    | 'passwordCantBeReused'
    | 'cantIdentifyTheUser';
export const ChangePasswordContainerCmsWithDefault: CmsObjectWithDefault<ChangePasswordContainerCmsKey> = {
    passwordValidationEmpty: {
        cmsId: 76304,
        defaultTranslation: 'Your password is empty, please fill in the password',
    },
    confirmPasswordValidationMatch: {
        cmsId: 76305,
        defaultTranslation: 'Passwords do not match. Please re-enter passwords.',
    },
    confirmPasswordValidationLength: {
        cmsId: 76577,
        defaultTranslation: 'Please enter a valid password, Must be a minimum 8 Characters',
    },
    pleaseTryAgain: {
        cmsId: 269092,
        defaultTranslation: 'Sorry, we have encountered a technical issue. Please try again.',
    },
    technicalDifficulty: {
        cmsId: 101793,
        defaultTranslation: 'We are currently experiencing technical difficulties.',
    },
    serverError: {
        cmsId: 82924,
        defaultTranslation: 'Server error',
    },
    passwordIsChangedSuccessfully: {
        cmsId: 67075,
        defaultTranslation: 'Password is changed successfully',
    },
    youAreNotAllowedToLogIn: {
        cmsId: 115056,
        defaultTranslation: 'You are not allowed to log in.',
    },
    passwordCantBeReused: {
        cmsId: 69296,
        defaultTranslation: 'For your security password cannot be reused',
    },
    cantIdentifyTheUser: {
        cmsId: 82600,
        defaultTranslation: "Sorry, we weren't able to identify you given the information provided.",
    },
};
